import { render, staticRenderFns } from "./HomeDiscovery.vue?vue&type=template&id=436d2d46&scoped=true&"
import script from "./HomeDiscovery.vue?vue&type=script&lang=js&"
export * from "./HomeDiscovery.vue?vue&type=script&lang=js&"
import style0 from "./HomeDiscovery.vue?vue&type=style&index=0&id=436d2d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436d2d46",
  null
  
)

export default component.exports